module.exports = __webpack_public_path__ + "img/maison14.7949fd32.jpg";